import * as React from "react"
import { ErrorModal } from "@modules/modal"
import {
  useMaintenanceMode,
  isMaintenanceError,
} from "@modules/serviceRoutes/utils"
import { UserOrganizationsDropdown } from "./UserOrganizationsDropdown"
import { useOrganizationInfo } from "./UserOrganizationsHeader.helpers"
import { ThemeCss } from "gatsby-interface"

export type UserOrganizationsHeaderProps = {
  pathname: string
}

export function UserOrganizationsHeader({
  pathname,
}: UserOrganizationsHeaderProps) {
  const {
    currentOrganizations,
    selectedOrganizationName,
    selectedOrganizationId,
    error,
  } = useOrganizationInfo()

  useMaintenanceMode({ error })

  if (error) {
    if (isMaintenanceError(error)) {
      return null
    }
    return <ErrorModal errMsg={error.message} />
  }

  return selectedOrganizationId && selectedOrganizationName ? (
    <div css={rootCss}>
      <UserOrganizationsDropdown
        userOrganizations={currentOrganizations}
        selectedOrganizationId={selectedOrganizationId}
        path={pathname}
      />
    </div>
  ) : null
}

/* styles */

const rootCss: ThemeCss = () => ({
  display: `flex`,
  flexGrow: 1,
  justifyContent: `space-between`,
  alignItems: `center`,
  width: `auto`,
  overflow: `hidden`,
})
